var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{attrs:{"id":"communication-message-card"}},[(_vm.props.type)?_c(_vm.injections.components[_vm.props.type],{tag:"component",attrs:{"data":_vm.props.data,"parentEl":'#communication-message-card'}}):_c('div',[_vm._v("Nothing")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }